import * as transactions from '@blockcatio/tabby-library/lib/actions/transactions';

import * as account from './account';
import * as app from './app';
import * as campaigns from './campaigns';
import * as createCampaign from './createCampaign';
import * as redeemReward from './redeemReward';
import * as token from './token';

export default {
  ...account,
  ...app,
  ...campaigns,
  ...createCampaign,
  ...redeemReward,
  ...transactions,
  ...token,
};



// WEBPACK FOOTER //
// ./src/actions/index.js